import React, { FC } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { FirebaseDocRefType } from 'firebase/index'
import { SelectBox } from 'components/Form'
import { useTimesWithRange } from 'hooks/store'
import { DeleteIconButton } from 'components/Button'

type Props = {
  dataCy?: string
  deleteStockRow: (stockRef: FirebaseDocRefType) => void
  earliestLastPickupTime: string
  handleStock: (stockRef: FirebaseDocRefType, type: 'plus' | 'minus') => void
  latestOpenTime: string
  pickupableTime: string
  selectPickupableTime: (stockRef: FirebaseDocRefType, value: string) => void
  stock: number
  stockRef: FirebaseDocRefType
}

const StockCardRowEditable: FC<Props> = React.memo((props) => {
  const {
    dataCy,
    deleteStockRow,
    earliestLastPickupTime,
    handleStock,
    latestOpenTime,
    pickupableTime,
    selectPickupableTime,
    stock,
    stockRef,
  } = props

  const pickupableTimeOptions = useTimesWithRange(latestOpenTime, earliestLastPickupTime)
  const dataCyStr = dataCy ? `stock-card-row-editable-${dataCy}` : 'stock-card-row-editable'

  return (
    <FlexRow dataCy={dataCyStr} justifyContent={'between'}>
      <div className={styles.row__pickupableTime}>
        <SelectBox
          options={pickupableTimeOptions}
          select={(value) => selectPickupableTime(stockRef, value)}
          value={pickupableTime}
        />
      </div>
      <Spacer size={16} axis={'horizontal'} />
      <FlexRow justifyContent={'between'}>
        <button
          className={styles.row__button}
          data-cy={'button-stock-minus'}
          disabled={stock <= 0}
          onClick={() => handleStock(stockRef, 'minus')}
        >
          <img
            className={classNames(text.pointerEventsNone, text.userSelectNone)}
            src={stock <= 0 ? '/icon/grey/minus_28x29.svg' : '/icon/orange/minus.svg'}
            alt={'在庫を減らす'}
          />
        </button>
        <Spacer size={24} axis={'horizontal'} />
        <span
          className={classNames(text.font_xxlarge, text.pointerEventsNone, text.userSelectNone, {
            [text.color_orange_main]: stock === 0,
            [text.font_bold]: stock === 0,
          })}
          data-cy={`stock-${pickupableTime.replace(':', '')}`}
          onTouchStart={(e) => e.preventDefault()}
        >
          {stock.toLocaleString()}
        </span>
        <Spacer size={24} axis={'horizontal'} />
        <button
          className={styles.row__button}
          data-cy={'button-stock-plus'}
          onClick={() => handleStock(stockRef, 'plus')}
        >
          <img
            className={classNames(text.pointerEventsNone, text.userSelectNone)}
            src={'/icon/orange/plus.svg'}
            alt={'在庫を増やす'}
          />
        </button>
        <Spacer size={8} axis={'horizontal'} />
        <DeleteIconButton dataCy={'stock'} onClick={() => deleteStockRow(stockRef)} />
      </FlexRow>
    </FlexRow>
  )
})

export default StockCardRowEditable
